import React from "react";
import LeagueWizard from "./wizard/LeagueWizard";

// Route entry for /contest/create-private-league.
//
// Shares every input and step with the public flow — see LeagueWizard. The
// `private` variant in wizard/leagueWizardConfig.js supplies the copy, the
// qushi.io/join/ link prefix, the prize/reward + cash-prize fields, and the
// hand-off to /contest/private-league-created with the invite code.
const CreatePrivateLeagueWizard = () => <LeagueWizard variant="private" />;

export default CreatePrivateLeagueWizard;
